// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"9513":"12c97dcbbb08d0ae","9707":"bde51b0344b5b9d3"}[chunkId] + ".css";
};